import { FormSection } from '@@/form-components/FormSection';

interface Props {
  title: string;
  message: string;
}

/**
 * Shows a consistent empty-state block for read-only policy sections.
 */
export function PolicyEmptyState({ title, message }: Props) {
  return (
    <FormSection title={title}>
      <div className="text-muted rounded-lg border border-gray-5 bg-gray-2 p-4 text-sm th-dark:border-gray-7 th-dark:bg-gray-iron-10">
        {message}
      </div>
    </FormSection>
  );
}
